import { useLayoutEffect, useState, type RefObject } from 'react';

const ICON_AND_PADDING_PX = 85;

const useWidth = (label: string | undefined, spanRef: RefObject<HTMLSpanElement>) => {
  const [width, setWidth] = useState<number>(200);

  useLayoutEffect(() => {
    if (spanRef.current && label) {
      const measured = spanRef.current.getBoundingClientRect().width;
      setWidth(Math.max(Math.ceil(measured) + ICON_AND_PADDING_PX, 200));
    }
  }, [label, spanRef]);

  return width;
};

export default useWidth;
